import { useContext, useEffect, useMemo, useState } from "react";
import ThemeContext from "../../../../../../../context/theme/ThemeContext";
import SelectedItemHeader from "./components/Header";
import { deleteContact, updateContact } from "../../../../../../../api/contacts";
import { deleteLocationOfGoods, updateLocationOfGoods } from "../../../../../../../api/locationOfGoods";
import { deleteCommodityCode, updateCommodityCode } from "../../../../../../../api/commodity-codes";
import { useTranslation } from "react-i18next";
import SearchItemElement from "./components/SearchItemElement";

const SearchPageSelectedItem = (props) => {
	const { item, searchType, onDelete, elements, isInModal, onBackClick } = props;
	const [inputValues, setInputValues] = useState({});
	const { withTheme } = useContext(ThemeContext);
	const [isEditModeEnabled, setIsEditModeEnabled] = useState(false);
	const [isSaveLoading, setIsSaveLoading] = useState(false);
	const [isDeleteLoading, setIsDeleteLoading] = useState(false);
	const { t } = useTranslation();

	const { emptyPageMessage, itemData } = useMemo(() => {
		if (searchType === "contacts") {
			return {
				emptyPageMessage: t("contactNotSelectedMessage"),
				itemData: item?.jdeclaration?.data?.contact,
			};
		} else if (searchType === "locationOfGoods") {
			return {
				emptyPageMessage: t("locationNotSelectedMessage"),
				itemData: item?.goodsLocation?.data,
			};
		} else if (searchType === "commodityCodes") {
			return {
				emptyPageMessage: t("comodityCodeNotSelectedMessage"),
				itemData: item?.commodityCodes?.data,
			};
		}
	}, [item, searchType]);

	// TODO: Item data needs to get updated immediately after onSave
	// TODO: ^^ Should update contacts state
	const handleSaveClick = async () => {
		setIsSaveLoading(true);
		try {
			if (searchType === "contacts") {
				await updateContact(item.creationTime, {
					role: item.jdeclaration?.data?.role || "importer",
					contact: inputValues,
				});
			} else if (searchType === "locationOfGoods") {
				await updateLocationOfGoods(item.creationTime, inputValues);
			} else if (searchType === "commodityCodes") {
				await updateCommodityCode(item.creationTime, inputValues);
			}
		} catch (e) {
			console.log(e);
		}

		setIsSaveLoading(false);
		setIsEditModeEnabled(!isEditModeEnabled);
	};

	const handleDeleteClick = async () => {
		setIsDeleteLoading(true);

		if (searchType === "contacts") {
			await deleteContact(item.creationTime);
		} else if (searchType === "locationOfGoods") {
			await deleteLocationOfGoods(item.creationTime);
		} else if (searchType === "commodityCodes") {
			await deleteCommodityCode(item.creationTime);
		}

		setIsDeleteLoading(false);
		onDelete(item);
	};

	const handleInputChange = (e) => {
		if (isSaveLoading) {
			return;
		}

		const { name, value } = e.target;

		setInputValues({
			...inputValues,
			[name]: value,
		});
	};

	const handleDismissClick = () => {
		setIsEditModeEnabled(false);
		setInputValues({ ...itemData });
	};

	// TODO: Item data needs to get updated immediately after onSave
	useEffect(() => {
		setInputValues({ ...itemData });
	}, [itemData]);

	if (!item) {
		return (
			<div style={{ paddingTop: 92 }} className={withTheme("empty-page-text")}>
				{emptyPageMessage}
			</div>
		);
	}

	return (
		<div style={{ width: "100%" }}>
			{!isInModal && (
				<SelectedItemHeader
					searchType={searchType}
					item={item}
					itemData={itemData}
					isSaveLoading={isSaveLoading}
					isDeleteLoading={isDeleteLoading}
					onDeleteClick={handleDeleteClick}
					onEditClick={() => setIsEditModeEnabled(!isEditModeEnabled)}
					onSaveClick={handleSaveClick}
					onDismissClick={handleDismissClick}
					onBackClick={onBackClick}
					isEditModeEnabled={isEditModeEnabled}
				/>
			)}

			<div style={{ display: "flex", flexWrap: "wrap", columnGap: 20 }}>
				{elements.map((elementName, index) => (
					<SearchItemElement
						key={index}
						isEditModeEnabled={isEditModeEnabled}
						elementName={elementName}
						value={inputValues[elementName]}
						onInputChange={handleInputChange}
					/>
				))}
			</div>
		</div>
	);
};

export default SearchPageSelectedItem;
